/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum EntryType {
    CALL = 'Call',
    TEXT = 'Text',
}
